import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { FlexingBox } from '../../components/Flex'
import { spacing } from '../../theme'
import { H5Bold, H6 } from '../../components/Typography'
import { ButtonGreen } from '../../components/Buttons'

const Container = styled(FlexingBox)`
  overflow: visible;
  margin-top: ${spacing.large};
  margin-right: ${spacing.large};
  max-width: 680px;
  padding: ${spacing.xl};
  gap: ${spacing.xxxl};
  align-items: center;
  min-height: auto;
`

export function AccountingPrefNotConfigured(): React.JSX.Element {
  const history = useHistory()

  return (
    <Container>
      <H5Bold data-testid='no-profile-title'>
        Här kommer det visas grafer över ert klimatavtryck!
      </H5Bold>

      <H6 data-testid='working'>
        Men först måste ni fylla i er redovisningsinformation.
      </H6>
      <ButtonGreen
        onClick={() => {
          history.push('/accountant-conf')
        }}
      >
        Gå till redovisningsinformation
      </ButtonGreen>
    </Container>
  )
}
